import React, { useContext } from 'react';
import { View as RNView, ViewStyle } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { ColorThemeContext, grid } from '@shared/styles';

export function Divider({
  style = {},
  vertical = false,
}: {
  style?: ViewStyle;
  vertical?: boolean;
}) {
  const colors = useContext(ColorThemeContext);

  if (vertical) {
    return (
      <RNView
        style={[
          {
            width: 1,
            backgroundColor: colors.input.borderInactive,
            marginHorizontal: grid(1),
          },
          style,
        ]}
      />
    );
  }

  return (
    <MBView
      style={[
        {
          borderBottomColor: colors.section.border,
          borderBottomWidth: 1,
          borderStyle: 'solid',
          width: '100%',
          marginBottom: grid(1),
        },
        style,
      ]}
    />
  );
}
